module.exports = __webpack_public_path__ + "d0ca489cf24e678ae50d65142a4cdb5b.jpg";